// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607200533/js/" + chunkId + "." + {"44":"518b0c10","225":"14df2950","481":"708c60bd","486":"20fe823c","770":"a8b94098"}[chunkId] + ".0.7355061579987392.chunk.js";
};